import { masterStoreForm } from '@/pages/store-management/master-stores/service';
import { FormError, validBlank, validMaxStr } from '@/validate';
import { validNum } from '@/validate/number';

const { MAX_255 } = validNum;

export type MasterStoreFormError = {
  name: FormError;
  authStore: FormError;
  associateBrand: FormError;
  businessNumber: FormError;
  businessName: FormError;
};

export const validateName = (
  name: string,
  error: MasterStoreFormError
): MasterStoreFormError => {
  error.name.isTouched = true;
  const label = masterStoreForm.name.label;
  const isMax = validMaxStr.check(name, MAX_255);
  const isBlank = validBlank.check(name);
  if (isBlank) error.name.message = validBlank.message(label);
  if (isMax) error.name.message = validMaxStr.message(label, MAX_255);
  error.name.isError = isBlank || isMax;
  return error;
};

export const validateAuthStore = (
  value: string,
  error: MasterStoreFormError
): MasterStoreFormError => {
  error.authStore.isTouched = true;
  const label = masterStoreForm.authStoreName.label;
  const isBlank = validBlank.check(value);
  if (isBlank) error.authStore.message = validBlank.message(label);
  error.authStore.isError = isBlank;
  return error;
};

export const validateAssociateBrand = (
  value: string,
  error: MasterStoreFormError
): MasterStoreFormError => {
  error.associateBrand.isTouched = true;
  const label = masterStoreForm.associatebrandName.label;
  const isBlank = validBlank.check(value);
  if (isBlank) error.associateBrand.message = validBlank.message(label);
  error.associateBrand.isError = isBlank;
  return error;
};

export const validateBusinessName = (
  value: string,
  error: MasterStoreFormError
): MasterStoreFormError => {
  error.businessName.isTouched = true;
  const label = masterStoreForm.businessName.label;
  const isMax = validMaxStr.check(value, MAX_255);
  if (isMax) error.businessName.message = validMaxStr.message(label, MAX_255);
  error.businessName.isError = isMax;
  return error;
};

export const validateStoreSidebarInput = (
  masterStoreName: string,
  authStoreSelectInput: string,
  associateBrandSelectInput: string,
  masterStoreBusinessName: string,
  error: MasterStoreFormError
): boolean => {
  console.log(error.businessName.message);
  return [
    validateName(masterStoreName, error).name.isError,
    validateAuthStore(authStoreSelectInput, error).authStore.isError,
    validateAssociateBrand(associateBrandSelectInput, error).associateBrand
      .isError,
    validateBusinessName(masterStoreBusinessName, error).businessName.isError,
  ].some((err) => err);
};
